import { render } from "./TorMySchoolPage.vue?vue&type=template&id=2e88c6dc&scoped=true"
import script from "./TorMySchoolPage.vue?vue&type=script&lang=js"
export * from "./TorMySchoolPage.vue?vue&type=script&lang=js"

import "./TorMySchoolPage.vue?vue&type=style&index=0&id=2e88c6dc&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e88c6dc"]])

export default __exports__